"use client"

import type React from "react"

import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Chip from "@mui/material/Chip";

import Search from "@mui/icons-material/Search";
import Clear from "@mui/icons-material/Clear";

interface SearchBarProps {
  searchTerm: string
  onSearchChange: (term: string) => void
  onClearSearch: () => void
  isSearching: boolean
  resultCount?: number
}

export const SearchBar: React.FC<SearchBarProps> = ({
  searchTerm,
  onSearchChange,
  onClearSearch,
  isSearching,
  resultCount,
}) => {
  return (
    <Box sx={{ paddingX: 2, pb: 1, borderBottom: "1px solid", borderColor: "divider" }}>
      <TextField
        fullWidth
        size="small"
        placeholder="파일 또는 폴더 검색..."
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search sx={{ color: "text.secondary" }} />
            </InputAdornment>
          ),
          endAdornment: isSearching && (
            <InputAdornment position="end">
              <IconButton size="small" onClick={onClearSearch}>
                <Clear />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      {isSearching && resultCount !== undefined && (
        <Box sx={{ mt: 1, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Chip label={`${resultCount}개 항목 발견`} size="small" color="primary" variant="outlined" />
        </Box>
      )}
    </Box>
  )
}


